import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-odoo-dev',
  templateUrl: './hire-odoo-dev.component.html',
  styleUrls: ['./hire-odoo-dev.component.css']
})
export class HireOdooDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-odoo-dev/hire-odoo-dev.component.ts